<div class="carousel-container" #carousel (window:resize)="onResize()">

  <div
    class="carousel-button"
    [ngClass]="{ 'carousel-button-hidden': hideArrows() }"
  >
    <button
      title="Previous"
      (click)="onPrevItem()"
      [disabled]="scrollLimit() === -1 || !allowScroll()"
    >
      <fa-icon [icon]="prevIcon()" width="30" />
    </button>
  </div>

  <div
    #carouselTrack
    class="carousel-track"
    [ngClass]="{ 'carousel-track-scrollbar': hideArrows() }"
    (scroll)="onScroll()"
  >
    @for(item of value(); track item) {
      <div class="carousel-item">
        <ng-template
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ $implicit: item }"
        />
      </div>
    }
  </div>

  <div
    class="carousel-button"
    [ngClass]="{ 'carousel-button-hidden': hideArrows() }"
  >
    <button
      title="Next"
      (click)="onNexItem()"
      [disabled]="scrollLimit() === 1 || !allowScroll()"
    >
      <fa-icon [icon]="nextIcon()" width="30" />
    </button>
  </div>
</div>
